import PropTypes from "prop-types";

export default {
	title: PropTypes.string,
	delay: PropTypes.number,
	grid: PropTypes.array,
	isVisible: PropTypes.bool,
};
